import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "left_menu" }

import { ref } from 'vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['clickChild'],
  setup(__props, { emit: __emit }) {

    const emit = __emit
    let selectTagId = ref('涉税咨询')

    const clickChild=(name:string)=>{
        selectTagId.value = name
        emit('clickChild',name)
    }
    clickChild('涉税咨询')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["tit", { 'active': _unref(selectTagId) === '涉税咨询' }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (clickChild('涉税咨询')))
    }, "涉税咨询", 2),
    _createElementVNode("a", {
      class: _normalizeClass(["tit", { 'active': _unref(selectTagId) === '特聘专家' }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (clickChild('特聘专家')))
    }, "特聘专家", 2)
  ]))
}
}

})